import { css } from '@emotion/css'
import { Section } from 'Shared/backend/widgets/Section';
import { theme } from 'Shared/ThemeProvider';
import { addItemAndOpen, StoreRepeater } from 'Shared/forms/StoreRepeater';
import { ComponentTitle } from 'Shared/backend/widgets/ComponentTitle';
import { StoreProvider, useStore } from 'Shared/StoreProvider';
import { initImage } from 'Shared/backend/widgets/LayoutSelector';
import { Show, createMemo } from 'solid-js';
import { useLayout } from 'Shared/backend/LayoutProvider';
import { StyleTags } from 'Shared/backend/StyleTags';
import { useVenue } from 'Shared/VenueProvider';
import { ActiveStylesProvider } from 'Shared/backend/ActiveStylesContext';

//TODO ben open showcasefields as an overlay like event > lineup artist forms, CJ couldn't get working 

const sectionStyle = () => css({
	marginBottom: '2em'
});

export const repeaterBarStyle = {
	paddingTop: 0,
	paddingBottom: 0,
	height: 48
};

/*
	XXX Could add 'prebuilt widgets' if necessary - similar to Chris' old widgets, which included:

	Venue Photo with Logo Overlayed
	Table of Contents
	Info with no image
	Images with info overlayed
	Images right of info
	Images left of info
	Same headings, images then details
	Images then same info
	Gallery: Images with same info
	Parallax image

	XXX COULD potentially have facade widgets that wrap component trees to simplify data entry.
	    Suspect this might be an unnecessarily complex approach. Could always just add a few 
		more components if necessary.

	XXX A BETTER alternative might be to have prebuilt PAGES instead.
*/

export function SectionList(P:{layout})
{
	const venue = useVenue();
	const sw = useStore();

	/* Compute which style names are currently active at the page level:
	   site styles, minus whatever the page cancels, plus whatever the page adds. */
	const activeStyles = createMemo(() => {
		const siteStyles = (venue.styles ?? []).map((s: any) => ({ category: s.category, type: s.type ?? s }));
		const pageRemoveStyles: {category:string,type:string}[] = (sw.store as any).removeStyles ?? [];
		const pageStyles = ((sw.store as any).styles ?? []).map((s: any) => ({ category: s.category, type: s.type ?? s }));
		return [
			...siteStyles.filter(s => !pageRemoveStyles.some(r => r.category === s.category && r.type === s.type)),
			...pageStyles,
		];
	});

	const headingLineStyle = css({
		margin: '1em 0',
		display: 'flex',
		gap: '0.7em',
		alignItems: 'center'
	});

	const headingStyle = () => css(P.headingStyle, {
		margin: 0,
		display: 'inline'
	});

	let itemsNode!:HTMLElement;
	const lo = useLayout();

	return (
		<ActiveStylesProvider activeStyles={activeStyles}>
		<section class={sectionStyle()}>
			<div class={headingLineStyle}>
				<h3 class={headingStyle()}>Page sections</h3>

				<a class={css(theme().a)} href='' onClick={() => lo.setLayout(!lo.layout())}>
					({lo.layout() ? 'Showing content plus layout infomation' : 'Only showing content'})
				</a>
			</div>

			<Show when={lo.layout()}>
				<StyleTags />
			</Show>

			<StoreRepeater ref={itemsNode} field='layout' 
				renderTitle={i => <SectionTitle {...i()} /> } 
				hideDelete={!lo.layout()}
				barStyle={repeaterBarStyle}
			>
				{(item,index) => (
					<StoreProvider {...sw} location={['layout',index]}>
						<Section {...P.layout[index]} index={index} />
					</StoreProvider>
				)}
			</StoreRepeater>

			<Show when={lo.layout()}>
				<button class={css(theme().button)} onClick={() => addItemAndOpen(sw,'layout',itemsNode,initImage())}>
					<i class='fas fa-plus'/> Add Section
				</button>
			</Show>
		</section>
		</ActiveStylesProvider>
	);
}

function SectionTitle(P)
{
	return (<>
		<Show when={P.disable}>
			<span style={{color:theme().palette.error}}>DISABLED</span> {' '}
		</Show>

		<ComponentTitle {...P} />
	</>);
}

